module.exports = __webpack_public_path__ + "static/media/utlogo.c9f5d72c.png";